import styled, { css } from 'styled-components';
import { match } from 'react-router';
import { RouteMatchProps } from '../../types';

export const LoginPopup = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .5);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PopupWrapper = styled.div<{ hasWhiteBackground?: match<RouteMatchProps> | null;}>`
    width: 400px;
    height: auto;
    background: var(--dark);
    border-radius: 8px;
    padding: 64px;
    position: relative;

    ${({ hasWhiteBackground }) => hasWhiteBackground && css`
        background: var(--white);

        input {
            background-color: #F7FAFC !important;
            border: 1px solid transparent !important;

            &:focus {
                outline: none !important;
                border: 1px solid var(--primary) !important;
                background: var(--white) !important;
            }
        }
    `}

    .close-btn {
        border: none;
        position: absolute;
        width: 42px;
        height: 42px;
        background: rgb(217, 84, 79);
        border-radius: 100%;
        top: -21px;
        right: -21px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;
        cursor: pointer;

        &:focus {
            outline: none;
        }

        svg {
            fill: var(--white);
            height: 24px;
            width: 24px;
        }
    }
`;

export const Form = styled.form`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .username,
    .password {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;

        label {
            margin-bottom: 4px;
            font-size: 14px;
        }

        input {
            background-color: var(--transparent);
            box-shadow: none;
            color: var(--transparent);
            background-color: #1A1D24;
            border: 1px solid var(--grey);
            padding: 1.3rem 1.5rem;
            border-radius: 0.7rem;

            &:focus {
                outline: none;
            }
        }
    }

    .error {
        color: #D36565 !important;
        font-style: initial;
        font-size: 12px;
        font-weight: 400;
        display: block;
        margin-bottom: 16px;
    }

    .login-btn {
        padding: 14px 32px;
        margin-top: 16px;
        font-size: 16px;
    }
`